enum ActionType {
    Add = 'Add',
    Remove = 'Remove',
    Change = 'Change',
    Clear = 'Clear'
}

export default ActionType;
